import { render, staticRenderFns } from "./DeleHome.vue?vue&type=template&id=5b80c40a&"
import script from "./DeleHome.vue?vue&type=script&lang=js&"
export * from "./DeleHome.vue?vue&type=script&lang=js&"
import style0 from "./DeleHome.vue?vue&type=style&index=0&id=5b80c40a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports